import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'esc-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent {
  @Input() public length: number;
  @Input() public pageSizeOptions: number[];
  @Input() public pageSize: number;
  @Input() public page: number;
  @Input() public id: string;

  @Output() public onPageChange = new EventEmitter();

  public handlePageChange(newPage: number) {
    this.updatePage({ pageIndex: newPage, pageSize: this.pageSize });
  }

  public handlePageSizeChange(newPageSize: number) {
    this.updatePage({ pageIndex: this.page, pageSize: newPageSize });
  }

  public updatePage(data: { pageIndex: number; pageSize: number }): void {
    this.onPageChange.emit(data);
  }

  public get start(): number {
    return (this.page - 1) * this.pageSize + 1;
  }

  public get end(): number {
    return Math.min(this.page * this.pageSize, this.length);
  }
}
